import { useEffect, useState } from 'react';
import Select from 'react-select';
import Pagination from '@src/common/Pagination';
import { NavLink, useNavigate } from 'react-router-dom';
import LeadHistoryModal from '@src/component/insurance/common/LeadHistoryModal';
import LeadRemarksModal from '@src/component/insurance/common/LeadRemarksModal';
import dateFormat from "dateformat";
import * as HELPER from "@src/config/helper";
import { updateLeadAssignUser } from "@src/store/slices/insurance";
import { ROLE_FEATURES, INS_TYPE_CTPL, FEATURE_LISTING, COUNTRY_CODE,LEAD_TYPE_CRM,APP_TYPE_RENEWAL,APP_TYPE_STANDALONE,STANDALONE_RENEWALS, PRIORITY } from '@src/config/constant';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useLanguage } from '@src/context/LanguageContext';


function InsuranceListTable(props: any) {
    let { insuranceList, paginationData, selectedFilters, assignUsers } = props;

    const navigate = useNavigate();

    const [viewTimeLine, setViewTimeLine] = useState(false);
    const [remarkHistory, setRemarkHistory] = useState(false);
    const {translations} = useLanguage();

    const page = 1;

    const [selectedRemarkLead, setSelectedRemarkLead] = useState<any>(0);

    const [insuranceListData, setInsuranceListData] = useState<any>([]);
    const [showSelectedAssignSave, setShowSelectedAssignSave] = useState(0);

    const [selectedRemarkLeadStatus, setSelectedRemarkLeadStatus] = useState<any>(0);

    const commonState = useSelector((state: any) => state.common)

    useEffect(() => {
        setInsuranceListData(insuranceList);
    }, [insuranceList]);

    const handleChangeAssign = (leadId: any, e: any) => {
        let updatedInsuranceListData: any = insuranceListData.map((u: any) => { return (u.leadId === leadId) ? { ...u, 'assign_user_id': e.value } : u })
        setInsuranceListData(updatedInsuranceListData);
        setShowSelectedAssignSave(leadId);
    }

    const detailPageRedirect = (lead: any) => {
        let standaloneRenewals = 0;
        const leadSources = commonState.common?.lead_source;
        if (leadSources && Array.isArray(leadSources)) {
            const standaloneRenewalsdata = leadSources.find((src: any) => src.slug === STANDALONE_RENEWALS);
            standaloneRenewals = +standaloneRenewalsdata?.value;
        }
        if ((+lead.lead_type === LEAD_TYPE_CRM && COUNTRY_CODE === 'ph') || (+lead.apptype === APP_TYPE_RENEWAL) || (+lead.apptype === APP_TYPE_STANDALONE && +lead.source === standaloneRenewals) && COUNTRY_CODE =='ph') {
            navigate(`/details/under-verification/${lead.hashId}`);
        } else {
            navigate(`/details/personal-details/${lead.hashId}`);
        }
        // navigate(`/details/personal-details/${leadId}`);
    }

    const handleRequestData = (params: any) => {
        let apiParams = {
            ...selectedFilters,
            page_number: params.page_no
        }

        props.getInsuranceListing(apiParams)

    }

    /**
     * HAHNDLE TIMELINE POPUP
     * @param type 
     * @param leadId 
     */
    const handleViewTimeLine = (type: boolean, leadId: any) => {
        setViewTimeLine(type);
        setSelectedRemarkLead(leadId);

    }

    /**
     * HAHNDLE REMARK POPUP
     * @param type 
     * @param leadId 
     */
    const handleRemarkTimeline = (type: boolean, leadId: any, AllLeadData: any) => {
        setRemarkHistory(type);
        setSelectedRemarkLead(leadId);

        setSelectedRemarkLeadStatus(AllLeadData?.status_id);
    }

    const getSelectedAssignUser = (assignUserId: any) => {
        let getSelectedUser = assignUsers.find((u: any) => +u.value === +assignUserId);
        return getSelectedUser || null;
    }

    const saveAssignLeadHandler = (params: { hashId: string, action: string }) => {
        if (params.action === "cancel") {
            setShowSelectedAssignSave(0);
            setInsuranceListData([...insuranceList])
            // let updatedInsuranceListData: any = insuranceList.map((u: any)=> { return (u.hashId === params.hashId) ? {...u, 'assign_user_id': e.value} : u })
            // setInsuranceListData(updatedInsuranceListData);

        } else {
            let getLead: any = insuranceListData.find((ins: any) => ins.hashId === params.hashId) || {};
            updateLeadAssignUser({ lead_id: params.hashId, "assign_user_id": getLead['assign_user_id'] }).then(res => {
                handleRequestData({ ...selectedFilters, page_no: selectedFilters?.activeTab === 'myCases' ? 1 : selectedFilters?.page_number })
                setShowSelectedAssignSave(0)
            });
        }
    }

    const handleRedirect = (lead: any) => {
        let standaloneRenewals = 0;
        const leadSources = commonState.common?.lead_source;
        if (leadSources && Array.isArray(leadSources)) {
            const standaloneRenewalsdata = leadSources.find((src: any) => src.slug === STANDALONE_RENEWALS);
            standaloneRenewals = +standaloneRenewalsdata?.value;
        }
        if ((+lead.lead_type === LEAD_TYPE_CRM && COUNTRY_CODE === 'ph') || (+lead.apptype === APP_TYPE_RENEWAL) || (+lead.apptype === APP_TYPE_STANDALONE && +lead.source === standaloneRenewals)) {
            return `/details/under-verification/${lead.hashId}`;
        } else {
            return `/details/personal-details/${lead.hashId}`;
        }
        // return `/details/personal-details/${lead.hashId}`;
        
    }

    const getConditionalComponents = (key: string, params: any) => {
        switch (key) {
            case 'policy_details': {
                if (COUNTRY_CODE === 'id') {
                    return <h5 title={`${HELPER.addCurrencyFormatting(params.final_premium)}`}>Premium Amount {HELPER.addCurrencyFormatting(params.final_premium) || 0}</h5>
                } else {
                    return <>
                        <h5 title={`${HELPER.addCurrencyFormatting(params.gross_premium)}`}>Gross {HELPER.addCurrencyFormatting(params.gross_premium) || 0}</h5>
                        <span title={`${HELPER.addCurrencyFormatting(params.total_tax_amount)}`}>Tax {HELPER.addCurrencyFormatting(params.total_tax_amount) || 0}</span>
                        <span title={`${HELPER.addCurrencyFormatting(params.net_premium)}`}>Net {HELPER.addCurrencyFormatting(params.net_premium) || 0}</span>
                    </>
                }
            }

            case 'case_details': {
                if (COUNTRY_CODE === 'id') {
                    return <>
                        <h5 title={params.created_by_role}>{params.created_by_role || ""}</h5>
                        <span>{params.created_by_name || ""}</span>
                        <span>Created on</span>
                        <span>{dateFormat(params.applied_on, 'd mmm yyyy')}</span>
                    </>
                } else {
                    return <>
                        <h5 title={params.created_by_name}>{params.created_by_name || ""}</h5>
                        <span>{params.created_by_role || ""}</span>
                        <span>Created on</span>
                        <span>{dateFormat(params.applied_on, 'd mmm yyyy')}</span>
                    </>
                }
            }

            case 'status': {
                if (COUNTRY_CODE === 'id') {
                    return <>
                        <h5 title={params.status_name}>{params.status_name || ""}</h5>
                        <span>{params.sub_status_name || ""}</span>
                        <span>Last Updated</span>
                        <span>{moment(params.updated_at).format('DD MMM yyyy h:mm:ss a')}</span>
                    </>
                } else {
                    return <>
                        <h5 title={params.sub_status_name}>{params.sub_status_name || ""}</h5>
                        <span>Last Updated</span>
                        <span>{dateFormat(params.updated_at, 'd mmm yyyy')}</span>
                    </>
                }
            }

            default: {
                return <></>
            }
        }
    }

    const getInsuranceTypeLines = (insuranceType?: string) => {
        const formattedInsuranceType = insuranceType?.trim();

        if (!formattedInsuranceType) return [];

        const typeMatches = [...formattedInsuranceType.matchAll(/\b(?:Comprehensive|TLO)\b/gi)];

        if (typeMatches.length <= 1) {
            return [formattedInsuranceType];
        }

        return typeMatches.map((match, index) => {
            const startIndex = match.index ?? 0;
            const endIndex = index < typeMatches.length - 1
                ? (typeMatches[index + 1].index ?? formattedInsuranceType.length)
                : formattedInsuranceType.length;

            return formattedInsuranceType.slice(startIndex, endIndex).trim();
        }).filter(Boolean);
    }
    
    return (
        <div className={`lead-list-data-table managepanel-tab ${COUNTRY_CODE === 'id' ? 'lead-list-edited-table' : 'lead-list-priority'}`}>
            <table>
                <thead>
                    <tr>
                        <th>{translations.Insurance?.['Insurance ID'] || translations.commonMsg?.loading}</th>
                        {
                        (COUNTRY_CODE === 'ph')?  <th>{translations.Insurance?.['PRIORITY'] || translations.commonMsg?.loading}</th>:''
                        }
                        <th>{translations.Insurance?.['Customer Details'] || translations.commonMsg?.loading}</th>
                        <th>{translations.Insurance?.['Car Details'] || translations.commonMsg?.loading}</th>
                        <th>{translations.Insurance?.['Policy Details'] || translations.commonMsg?.loading}</th>
                        <th>{translations.Insurance?.['Case Details'] || translations.commonMsg?.loading}</th>
                        <th>{translations.commonMsg?.['status'] || translations.commonMsg?.loading}</th>
                        <th>{COUNTRY_CODE === 'id' ? translations.Insurance?.['Partner_Name'] || translations.commonMsg?.loading : 'Insurance'}</th>
                        {
                            FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['INSURER_NAME'] &&
                            <th>{translations.Insurance?.['Insurer Name'] || translations.commonMsg?.loading}</th>
                        }
                        {
                            FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['APPLICATION_TYPE'] &&
                            <th>{translations.Insurance?.['Application Type'] || translations.commonMsg?.loading}</th>
                        }
                        {
                            FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['ASSIGN_TO'] &&
                            HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['assign_lead_to_user'], accessType: 'isVisible' }) && <th>{translations.Insurance?.['Assign to'] || translations.commonMsg?.loading}</th>
                        }
                        <th>{translations.commonMsg?.['action'] || translations.commonMsg?.loading}</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        insuranceListData.length
                            ?
                            insuranceListData.map((lead: any, key: number) =>

                                <tr key={key}>
                                    <td style={{ display: "inline-block" }}>  <NavLink to={handleRedirect(lead)}> {lead.lead_code} </NavLink>
                                        {lead.renewal_insurance_id_code && <span className="renewed-tag" title={`Renewal Ins Id: ${lead.renewal_insurance_id_code}`}>{translations.Insurance?.['Renewed'] || translations.commonMsg?.loading}</span>}
                                    </td>
                                    {
                                        COUNTRY_CODE === 'ph' && (
                                            <td
                                            className={`
                                                ${
                                                +lead.priority === PRIORITY.P0
                                                    ? 'priority-red'
                                                    : +lead.priority === PRIORITY.P1
                                                    ? 'priority-bold'
                                                    : ''
                                                }
                                            `}
                                            >
                                            {
                                                commonState?.common?.priority
                                                ?.find((el: any) => +el.value === +lead.priority)
                                                ?.label || "-"
                                            }
                                            </td>
                                        )
                                    }
                                    <td>
                                        <div className="table-txt-data">
                                            <h5 title={`${lead.name}(${lead.phone})`}>{lead.name || ""}</h5>
                                            <span>{lead.phone || ""}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-txt-data">
                                            <h5 title={`${lead.make_name || ""} ${ COUNTRY_CODE ==='id'? lead?.parent_model_name:lead.model_name || ""} ${lead.version_name || ""}`}>{`${lead.make_name || ""} ${COUNTRY_CODE ==='id'? lead?.parent_model_name:lead.model_name || ""} ${lead.version_name || ""}`}</h5>
                                            <span>{lead.mfg_year || ""}</span>
                                            <span title="Plate Number">{lead.plate_no || ""}</span>
                                            {
                                                (lead.insurance_type === INS_TYPE_CTPL && lead.mv_number) && <span title="MV File number ">{lead.mv_number || ""}</span>
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-txt-data insurance-type-width">
                                            {
                                                getConditionalComponents('policy_details', lead)
                                            }
                                            {
                                                FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['POLICY_DETAILS']['INSURANCE_TYPE'] &&
                                                <span title={lead?.insurance_all_type} className="insurance-type-text">
                                                    {getInsuranceTypeLines(lead?.insurance_all_type).map((insuranceType: string, index: number) => (
                                                        <span key={`${lead?.hashId || lead?.leadId || key}-${index}`} className="insurance-type-line">
                                                            {insuranceType}
                                                        </span>
                                                    ))}
                                                    {/* {(commonState?.common?.insurance_type?.find((e: any) => lead.insurance_type === e.value))?.label || ""} */}
                                                </span>
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-txt-data">
                                            {
                                                getConditionalComponents('case_details', lead)
                                            }

                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-txt-data">
                                            {
                                                getConditionalComponents('status', lead)
                                            }

                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-txt-data">
                                            <h5 title={lead.insurance_partner}>{lead.insurance_partner || ""}</h5>
                                        </div>
                                    </td>
                                    {
                                        FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['INSURER_NAME'] &&
                                        <td>
                                            <div className="table-txt-data">
                                                <h5 title={lead.insurer_name}>{lead.insurer_name || ""}</h5>
                                            </div>
                                        </td>
                                    }
                                    {
                                        FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['APPLICATION_TYPE'] &&
                                        <td>
                                            <div className="table-txt-data">
                                                <h5 title={'application type'}>{(commonState?.common?.apptype?.find((e: any) => lead.apptype === e.value))?.label || ""}</h5>
                                            </div>
                                        </td>
                                    }

                                    {
                                        FEATURE_LISTING['INSURANCE_LIST']['SUMMARY']['ASSIGN_TO'] &&
                                        HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['assign_lead_to_user'], accessType: 'isVisible' }) && <td>
                                            <div className="select-table">
                                                <fieldset className="single-select">
                                                    <div className="material">
                                                        <Select
                                                            value={getSelectedAssignUser(lead.assign_user_id)}
                                                            onChange={(e) => handleChangeAssign(lead.leadId, e)}
                                                            options={assignUsers}
                                                            placeholder="Assign To"
                                                        />

                                                        {(showSelectedAssignSave === lead.leadId) && <div className="amt-edit-opt"><button className="btn-primary" onClick={() => saveAssignLeadHandler({ hashId: lead.hashId, action: 'save' })}>Save</button><i className="ic-clearclose" onClick={() => saveAssignLeadHandler({ hashId: lead.hashId, action: 'cancel' })}></i></div>}
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    }

                                    <td>
                                        <ul className="action-btn">
                                            <li onClick={() => detailPageRedirect(lead)}>
                                                <i className="ic-remove_red_eyevisibility"></i>

                                            </li>
                                            <li onClick={() => handleViewTimeLine(true, lead.leadId)}>
                                                <i className="ic-Call-history"></i>
                                            </li>
                                            
                                            {['id', 'ph'].includes(COUNTRY_CODE) && (
                                                <li onClick={() => handleRemarkTimeline(true, lead.leadId, lead)}>
                                                    <i className={COUNTRY_CODE === 'id' ? 'ic-application' : 'ic-chat'}></i>
                                                </li>
                                            )}
                                        </ul>
                                    </td>
                                </tr>

                            )

                            :
                            <tr><td colSpan={9} style={{ textAlign: 'center' }}>{translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}</td></tr>

                    }

                </tbody>
            </table>

            {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
                page,
                loading: false,
                totalLengthWithoutPagination: paginationData['total'],
                paginationData,
                filteredData: selectedFilters
            }}
                sendRequestDataToParent={handleRequestData} />}

            {viewTimeLine && <LeadHistoryModal viewTimeLine={viewTimeLine} selectedRemarkLead={selectedRemarkLead} handleViewTimeLine={(action: boolean, leadId: any) => handleViewTimeLine(action, leadId)} />}


            {remarkHistory && <LeadRemarksModal remarkHistory={remarkHistory} selectedRemarkLead={selectedRemarkLead} selectedRemarkLeadStatus={selectedRemarkLeadStatus} handleRemarkTimeline={(action: boolean, leadId: any, lead: any) => handleRemarkTimeline(action, leadId, lead)} remark_source={'insurance-list'} />}



        </div >
    )
}

export default InsuranceListTable